import { connectPagination } from 'instantsearch.js/es/connectors';
import { getInstance, registerWidget } from './algolia-create-instance';

const cssClasses = {
  root: 'tui-interface tui-pager tgblAlgolia-pagination',
  list: 'tui-pager__nav tui-flex tgblAlgolia-pagination__controls',
  item: 'tgblAlgolia-pagination__controls__item',
  link: 'tui-pager__item tui-button is-size-sm is-theme-secondary is-style-outline',
  disabledItem: 'tgblAlgolia-pagination__controls__item--disabled',
  selectedItem: 'tgblAlgolia-pagination__controls__item--active',
};

function initPaginationWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblAlgoliaDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);

  const elements = document.querySelectorAll("[data-filter-type='pagination']")
  const elementsArray = Array.from(elements);

  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];

      elementsWithSameIndex.forEach(element => {
        const widgetID = element.getAttribute('data-id');
        const indexName = element.getAttribute('data-index')
        const showFirst = tgblAlgoliaData[widgetID]['show_first']
        const showPrevious = tgblAlgoliaData[widgetID]['show_previous']
        const showNext = tgblAlgoliaData[widgetID]['show_next']
        const showLast = tgblAlgoliaData[widgetID]['show_last']
        const pinFirstPage = tgblAlgoliaData[widgetID]['pin_first_page']
        const pinLastPage = tgblAlgoliaData[widgetID]['pin_last_page']
        const paginationPadding = tgblAlgoliaData[widgetID]['padding']
        const hitsPerPage = tgblAlgoliaData[widgetID]['hits_per_page']
        const previousLabel = tgblAlgoliaData[widgetID]['previous_label']
        const nextLabel = tgblAlgoliaData[widgetID]['next_label']

        const search = getInstance(indexName)
        if ( Number.isInteger( hitsPerPage ) && hitsPerPage > 0 ) {
          search.once('render', () => {
            const configureState = search.renderState[indexName]?.configure;
            if (configureState) {
              configureState.refine({ hitsPerPage });
            }
          });
        }

        let AlgoliaPagination = ($, search, element) => {
          const renderPagination = (renderOptions, isFirstRender) => {
            const { pages, currentRefinement, nbPages, refine } = renderOptions;

            const pageSet = new Set();

            if (pinFirstPage) pageSet.add(0);
            pages.forEach(page => pageSet.add(page));
            if (pinLastPage) pageSet.add(nbPages - 1);

            const allPages = Array.from(pageSet).sort((a, b) => a - b);

            const pageLinks = allPages.map((page, index) => {
              const isSelected = page === currentRefinement;
              const itemClasses = [
                cssClasses.item,
                isSelected ? cssClasses.selectedItem : ''
              ].filter(Boolean).join(' ');

              let ellipsis = '';
              if (index > 0 && page - allPages[index - 1] > 1) {
                ellipsis = `<li class="${cssClasses.item} tgblAlgolia-pagination__controls__item--ellipsis">
                  <span class="tgblAlgolia-pagination__controls__item__ellipsis">&hellip;</span>
                </li>`;
              }

              return `${ellipsis}<li class="${itemClasses}">
                <a class="${cssClasses.link}" href="#" data-page="${page}">${page + 1}</a>
              </li>`;
            }).join('');

            const prevDisabled = currentRefinement === 0 ? cssClasses.disabledItem : '';
            const nextDisabled = currentRefinement === nbPages - 1 ? cssClasses.disabledItem : '';
            const firstDisabled = currentRefinement === 0 ? cssClasses.disabledItem : '';
            const lastDisabled = currentRefinement === nbPages - 1 ? cssClasses.disabledItem : '';

            element.innerHTML = `
              <div class="${cssClasses.root}">
                <ul class="${cssClasses.list}">
                  ${showFirst ? `<li class="${cssClasses.item} tgblAlgolia-pagination__controls__item--first ${firstDisabled}">
                    <a class="${cssClasses.link}" href="#" data-page="0">&laquo;</a>
                  </li>` : ''}
                  ${showPrevious ? `<li class="${cssClasses.item} tgblAlgolia-pagination__controls__item--previous ${prevDisabled}">
                    <a class="${cssClasses.link}" href="#" data-page="${currentRefinement - 1}">${previousLabel || '&lsaquo;'}</a>
                  </li>` : ''}
                  ${pageLinks}
                  ${showNext ? `<li class="${cssClasses.item} tgblAlgolia-pagination__controls__item--next ${nextDisabled}">
                    <a class="${cssClasses.link}" href="#" data-page="${currentRefinement + 1}">${nextLabel || '&rsaquo;'}</a>
                  </li>` : ''}
                  ${showLast ? `<li class="${cssClasses.item} tgblAlgolia-pagination__controls__item--last ${lastDisabled}">
                    <a class="${cssClasses.link}" href="#" data-page="${nbPages - 1}">&raquo;</a>
                  </li>` : ''}
                </ul>
              </div>
            `;

            element.querySelectorAll('a[data-page]').forEach(link => {
              link.addEventListener('click', (e) => {
                e.preventDefault();
                const page = parseInt(link.dataset.page, 10);
                if (page >= 0 && page < nbPages) {
                  refine(page);
                }
              });
            });
          };

          const customPagination = connectPagination(renderPagination);

          search.addWidgets([
            customPagination({
              padding: paginationPadding,
            })
          ]);
          registerWidget(element);
        };
        AlgoliaPagination($, search, element);
      });
    }
  }
}

export { initPaginationWidget }